import { render, staticRenderFns } from "./NotificationPushTable.vue?vue&type=template&id=ef02cdd0&"
import script from "./NotificationPushTable.vue?vue&type=script&lang=js&"
export * from "./NotificationPushTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports